import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "pwa-userinfo" }
const _hoisted_2 = { class: "pwa-header" }
const _hoisted_3 = { class: "pwa-content" }
const _hoisted_4 = { class: "info-section" }
const _hoisted_5 = { class: "info-item" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "info-section" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "info-section" }
const _hoisted_19 = { class: "info-item" }
const _hoisted_20 = { class: "phone-input-group" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "info-item" }
const _hoisted_25 = { class: "phone-input-group" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "info-item" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "info-item" }
const _hoisted_32 = { class: "phone-input-group" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "info-section" }
const _hoisted_37 = { class: "info-item" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "info-item" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "info-item" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "info-section" }
const _hoisted_44 = { class: "info-item" }
const _hoisted_45 = { class: "address-input-group" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "info-item" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "button-section" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "modal-field" }
const _hoisted_54 = { class: "input-with-icon" }
const _hoisted_55 = ["type", "disabled"]
const _hoisted_56 = { class: "modal-field" }
const _hoisted_57 = { class: "input-with-icon" }
const _hoisted_58 = ["type", "disabled"]
const _hoisted_59 = { class: "modal-field" }
const _hoisted_60 = { class: "input-with-icon" }
const _hoisted_61 = ["type", "disabled"]
const _hoisted_62 = {
  key: 0,
  class: "error-message"
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_66 = ["disabled"]

import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';

const API_BASE_URL = '/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaUserInfo',
  setup(__props) {

const store = useStore();
const router = useRouter();

const loading = ref(false);
const loadingText = ref('로딩 중...');
const passwordLoading = ref(false);
const snackbar = ref({ show: false, message: '', color: 'info' });
const addressDialog = ref(false);
const postcodeContainer = ref<HTMLDivElement | null>(null);
const addressLoading = ref(false);

// 비밀번호 변경 관련
const passwordDialog = ref(false);
const showCurrentPassword = ref(false);
const showNewPassword = ref(false);
const showConfirmNewPassword = ref(false);
const passwordError = ref('');

const passwordData = ref({
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: ''
});

let daumScriptLoading: Promise<void> | null = null;

// 사용자 정보
const userInfo = ref({
  m_idx: 0,
  m_id: '',
  m_sisul_code: '',
  m_longterm_code: '',
  m_pw: '',
  m_sisul_name: '',
  m_biz_gubun: '',
  m_biz_num: '',
  m_user_name: '',
  m_email: '',
  m_sisul_call_num1: '',
  m_sisul_call_num2: '',
  m_sisul_call_num3: '',
  m_phone1: '',
  m_phone2: '',
  m_phone3: '',
  m_fax1: '',
  m_fax2: '',
  m_fax3: '',
  m_bank_num: '',
  m_bank_name: '',
  m_bank_owner: '',
  m_addr: '',
  m_addr_detail: ''
});

// 폼 유효성 검사
const isFormValid = computed(() => {
  return userInfo.value.m_user_name && userInfo.value.m_sisul_name;
});

const isPasswordValid = computed(() => {
  return passwordData.value.currentPassword &&
         passwordData.value.newPassword &&
         passwordData.value.confirmNewPassword &&
         passwordData.value.newPassword === passwordData.value.confirmNewPassword &&
         passwordData.value.newPassword.length >= 6 &&
         !passwordError.value;
});

// 입력값 포맷터
const numbersOnly = (value: string) => value.replace(/[^\d]/g, '');

const formatPhone = (value: string) => {
  const digits = numbersOnly(value).slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,7)}-${digits.slice(7)}`;
};

const formatBizNum = (value: string) => {
  const digits = numbersOnly(value).slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,5)}-${digits.slice(5)}`;
};

// 비밀번호 유효성 검사
const validatePassword = () => {
  passwordError.value = '';
  
  if (passwordData.value.newPassword && passwordData.value.newPassword.length < 6) {
    passwordError.value = '비밀번호는 6자 이상이어야 합니다.';
    return;
  }
  
  if (passwordData.value.newPassword && passwordData.value.confirmNewPassword) {
    if (passwordData.value.newPassword !== passwordData.value.confirmNewPassword) {
      passwordError.value = '비밀번호가 일치하지 않습니다.';
      return;
    }
  }
};

// 주소 검색 관련 함수들
const loadDaumPostcodeScript = async (): Promise<void> => {
  if ((window as any).daum?.Postcode) return;
  if (daumScriptLoading) {
    await daumScriptLoading;
    return;
  }
  daumScriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  await daumScriptLoading;
};

const embedDaumPostcode = async () => {
  addressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    await nextTick();
    const container = postcodeContainer.value;
    if (!container) throw new Error('Container not ready');
    container.innerHTML = '';
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode is undefined');
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        userInfo.value.m_addr = selected || '';
        addressDialog.value = false;
        addressLoading.value = false;
      },
      onresize: (size: any) => {
        try {
          (container as HTMLDivElement).style.height = `${size.height}px`;
        } catch {}
      },
      width: '100%',
      height: '100%'
    });
    try {
      postcode.embed(container, { autoClose: true });
      addressLoading.value = false;
    } catch (e) {
      addressLoading.value = false;
      throw e;
    }
  } catch (e) {
    addressLoading.value = false;
    throw e;
  }
};

const openAddressModal = async () => {
  addressDialog.value = true;
};

watch(addressDialog, async (val) => {
  if (val) {
    try {
      await embedDaumPostcode();
    } catch (e) {
      addressDialog.value = false;
      store.commit('showSnackbar', { text: '주소 검색 로드에 실패했습니다.', color: 'error' });
    }
  }
});

// 뒤로가기
const goBack = () => {
  router.back();
};

// 비밀번호 변경 모달 열기
const openPasswordModal = () => {
  passwordData.value = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  passwordError.value = '';
  passwordDialog.value = true;
};

// 비밀번호 변경 모달 닫기
const closePasswordModal = () => {
  passwordDialog.value = false;
  passwordData.value = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  passwordError.value = '';
  showCurrentPassword.value = false;
  showNewPassword.value = false;
  showConfirmNewPassword.value = false;
};

// 비밀번호 변경
const changePassword = async () => {
  if (!isPasswordValid.value) return;
  
  passwordLoading.value = true;
  try {
    const response = await axios.put(`${API_BASE_URL}/auth/password`, {
      currentPassword: passwordData.value.currentPassword,
      newPassword: passwordData.value.newPassword
    }, {
      withCredentials: true,
      timeout: 10000
    });
    
    const result = response.data;
    
    if (result.success) {
      store.commit('showSnackbar', { text: '비밀번호가 성공적으로 변경되었습니다.', color: 'info' });
      closePasswordModal();
    } else {
      store.commit('showSnackbar', { text: result.message || '비밀번호 변경에 실패했습니다.', color: 'error' });
    }
  } catch (error: any) {
    console.error('비밀번호 변경 오류:', error);
    store.commit('showSnackbar', { 
      text: error.response?.data?.message || '비밀번호 변경 중 오류가 발생했습니다.', 
      color: 'error' 
    });
  } finally {
    passwordLoading.value = false;
  }
};

// 사용자 정보 수정
const updateUserInfo = async () => {
  if (!isFormValid.value) return;
  
  loading.value = true;
  loadingText.value = '정보를 수정하는 중...';
  try {
    const response = await axios.put(`${API_BASE_URL}/auth/account`, userInfo.value, {
      withCredentials: true,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    const result = response.data;
    if (result.success) {
      store.commit('setUser', userInfo.value);
      store.commit('showSnackbar', { text: '사용자 정보가 성공적으로 수정되었습니다.', color: 'info' });
    } else {
      store.commit('showSnackbar', { text: result.message || '사용자 정보 수정에 실패했습니다.', color: 'error' });
    }
  } catch (error: any) {
    console.error('사용자 정보 수정 오류:', error);
    store.commit('showSnackbar', { 
      text: error.response?.data?.message || '사용자 정보 수정 중 오류가 발생했습니다.', 
      color: 'error' 
    });
  } finally {
    loading.value = false;
  }
};

// 컴포넌트 마운트 시
onMounted(async () => {
  await store.dispatch('validateAuth');
  if (!store.getters.isLoggedIn) {
    router.push('/pwa/login');
    return;
  }
  
  const currentUser = store.getters.currentUser;
  if (currentUser) {
    userInfo.value = { ...currentUser };
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-btn",
        onClick: goBack
      }, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
            _createTextVNode("mdi-arrow-left", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[41] || (_cache[41] = _createElementVNode("h1", { class: "header-title" }, "내 정보", -1)),
      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "header-spacer" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[47] || (_cache[47] = _createElementVNode("h2", { class: "section-title" }, "기본 정보", -1)),
        _createElementVNode("div", _hoisted_5, [
          _cache[43] || (_cache[43] = _createElementVNode("label", { class: "info-label" }, "아이디", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userInfo.value.m_id) = $event)),
            type: "text",
            class: "info-input",
            readonly: "",
            disabled: loading.value
          }, null, 8, _hoisted_6), [
            [_vModelText, userInfo.value.m_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[44] || (_cache[44] = _createElementVNode("label", { class: "info-label" }, "장기요양기관기호", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userInfo.value.m_longterm_code) = $event)),
            type: "text",
            class: "info-input",
            readonly: "",
            disabled: loading.value
          }, null, 8, _hoisted_8), [
            [_vModelText, userInfo.value.m_longterm_code]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[45] || (_cache[45] = _createElementVNode("label", { class: "info-label" }, [
            _createTextVNode("사용자명 "),
            _createElementVNode("span", { class: "required" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userInfo.value.m_user_name) = $event)),
            type: "text",
            class: "info-input",
            placeholder: "사용자명을 입력하세요",
            disabled: loading.value,
            maxlength: "20"
          }, null, 8, _hoisted_10), [
            [_vModelText, userInfo.value.m_user_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[46] || (_cache[46] = _createElementVNode("label", { class: "info-label" }, [
            _createTextVNode("기관명 "),
            _createElementVNode("span", { class: "required" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userInfo.value.m_sisul_name) = $event)),
            type: "text",
            class: "info-input",
            placeholder: "기관명을 입력하세요",
            disabled: loading.value,
            maxlength: "50"
          }, null, 8, _hoisted_12), [
            [_vModelText, userInfo.value.m_sisul_name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[50] || (_cache[50] = _createElementVNode("h2", { class: "section-title" }, "업체 정보", -1)),
        _createElementVNode("div", _hoisted_14, [
          _cache[48] || (_cache[48] = _createElementVNode("label", { class: "info-label" }, "사업형태", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userInfo.value.m_biz_gubun) = $event)),
            type: "text",
            class: "info-input",
            placeholder: "사업형태를 입력하세요",
            disabled: loading.value,
            maxlength: "30"
          }, null, 8, _hoisted_15), [
            [_vModelText, userInfo.value.m_biz_gubun]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[49] || (_cache[49] = _createElementVNode("label", { class: "info-label" }, "사업자등록번호", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userInfo.value.m_biz_num) = $event)),
            type: "text",
            class: "info-input",
            placeholder: "123-45-67890",
            disabled: loading.value,
            onInput: _cache[6] || (_cache[6] = (e) => (userInfo.value.m_biz_num = formatBizNum(e.target.value))),
            maxlength: "12"
          }, null, 40, _hoisted_17), [
            [_vModelText, userInfo.value.m_biz_num]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[61] || (_cache[61] = _createElementVNode("h2", { class: "section-title" }, "연락처 정보", -1)),
        _createElementVNode("div", _hoisted_19, [
          _cache[53] || (_cache[53] = _createElementVNode("label", { class: "info-label" }, "기관 전화번호", -1)),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((userInfo.value.m_sisul_call_num1) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "02",
              disabled: loading.value,
              onInput: _cache[8] || (_cache[8] = (e) => (userInfo.value.m_sisul_call_num1 = numbersOnly(e.target.value).slice(0, 4))),
              maxlength: "4"
            }, null, 40, _hoisted_21), [
              [_vModelText, userInfo.value.m_sisul_call_num1]
            ]),
            _cache[51] || (_cache[51] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((userInfo.value.m_sisul_call_num2) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "1234",
              disabled: loading.value,
              onInput: _cache[10] || (_cache[10] = (e) => (userInfo.value.m_sisul_call_num2 = numbersOnly(e.target.value).slice(0, 4))),
              maxlength: "4"
            }, null, 40, _hoisted_22), [
              [_vModelText, userInfo.value.m_sisul_call_num2]
            ]),
            _cache[52] || (_cache[52] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((userInfo.value.m_sisul_call_num3) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "5678",
              disabled: loading.value,
              onInput: _cache[12] || (_cache[12] = (e) => (userInfo.value.m_sisul_call_num3 = numbersOnly(e.target.value).slice(0, 4))),
              maxlength: "4"
            }, null, 40, _hoisted_23), [
              [_vModelText, userInfo.value.m_sisul_call_num3]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[56] || (_cache[56] = _createElementVNode("label", { class: "info-label" }, "대표자 번호", -1)),
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((userInfo.value.m_phone1) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "010",
              disabled: loading.value,
              onInput: _cache[14] || (_cache[14] = (e) => (userInfo.value.m_phone1 = numbersOnly(e.target.value).slice(0, 3))),
              maxlength: "3"
            }, null, 40, _hoisted_26), [
              [_vModelText, userInfo.value.m_phone1]
            ]),
            _cache[54] || (_cache[54] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((userInfo.value.m_phone2) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "1234",
              disabled: loading.value,
              onInput: _cache[16] || (_cache[16] = (e) => (userInfo.value.m_phone2 = numbersOnly(e.target.value).slice(0, 4))),
              maxlength: "4"
            }, null, 40, _hoisted_27), [
              [_vModelText, userInfo.value.m_phone2]
            ]),
            _cache[55] || (_cache[55] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((userInfo.value.m_phone3) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "5678",
              disabled: loading.value,
              onInput: _cache[18] || (_cache[18] = (e) => (userInfo.value.m_phone3 = numbersOnly(e.target.value).slice(0, 4))),
              maxlength: "4"
            }, null, 40, _hoisted_28), [
              [_vModelText, userInfo.value.m_phone3]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[57] || (_cache[57] = _createElementVNode("label", { class: "info-label" }, "이메일", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((userInfo.value.m_email) = $event)),
            type: "email",
            class: "info-input",
            placeholder: "이메일을 입력하세요",
            disabled: loading.value,
            maxlength: "100"
          }, null, 8, _hoisted_30), [
            [_vModelText, userInfo.value.m_email]
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[60] || (_cache[60] = _createElementVNode("label", { class: "info-label" }, "팩스번호", -1)),
          _createElementVNode("div", _hoisted_32, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((userInfo.value.m_fax1) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "02",
              disabled: loading.value,
              onInput: _cache[21] || (_cache[21] = (e) => (userInfo.value.m_fax1 = numbersOnly(e.target.value).slice(0, 4))),
              maxlength: "4"
            }, null, 40, _hoisted_33), [
              [_vModelText, userInfo.value.m_fax1]
            ]),
            _cache[58] || (_cache[58] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((userInfo.value.m_fax2) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "1234",
              disabled: loading.value,
              onInput: _cache[23] || (_cache[23] = (e) => (userInfo.value.m_fax2 = numbersOnly(e.target.value).slice(0, 4))),
              maxlength: "4"
            }, null, 40, _hoisted_34), [
              [_vModelText, userInfo.value.m_fax2]
            ]),
            _cache[59] || (_cache[59] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((userInfo.value.m_fax3) = $event)),
              type: "text",
              class: "info-input phone-input",
              placeholder: "5678",
              disabled: loading.value,
              onInput: _cache[25] || (_cache[25] = (e) => (userInfo.value.m_fax3 = numbersOnly(e.target.value).slice(0, 4))),
              maxlength: "4"
            }, null, 40, _hoisted_35), [
              [_vModelText, userInfo.value.m_fax3]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _cache[65] || (_cache[65] = _createElementVNode("h2", { class: "section-title" }, "은행 정보", -1)),
        _createElementVNode("div", _hoisted_37, [
          _cache[62] || (_cache[62] = _createElementVNode("label", { class: "info-label" }, "은행명", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((userInfo.value.m_bank_name) = $event)),
            type: "text",
            class: "info-input",
            placeholder: "은행명을 입력하세요",
            disabled: loading.value,
            maxlength: "20"
          }, null, 8, _hoisted_38), [
            [_vModelText, userInfo.value.m_bank_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _cache[63] || (_cache[63] = _createElementVNode("label", { class: "info-label" }, "계좌번호", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((userInfo.value.m_bank_num) = $event)),
            type: "text",
            class: "info-input",
            placeholder: "계좌번호를 입력하세요",
            disabled: loading.value,
            maxlength: "50"
          }, null, 8, _hoisted_40), [
            [_vModelText, userInfo.value.m_bank_num]
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _cache[64] || (_cache[64] = _createElementVNode("label", { class: "info-label" }, "예금주", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((userInfo.value.m_bank_owner) = $event)),
            type: "text",
            class: "info-input",
            placeholder: "예금주를 입력하세요",
            disabled: loading.value,
            maxlength: "45"
          }, null, 8, _hoisted_42), [
            [_vModelText, userInfo.value.m_bank_owner]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _cache[68] || (_cache[68] = _createElementVNode("h2", { class: "section-title" }, "주소 정보", -1)),
        _createElementVNode("div", _hoisted_44, [
          _cache[66] || (_cache[66] = _createElementVNode("label", { class: "info-label" }, "주소", -1)),
          _createElementVNode("div", _hoisted_45, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((userInfo.value.m_addr) = $event)),
              type: "text",
              class: "info-input",
              placeholder: "도로명 주소",
              disabled: loading.value,
              readonly: "",
              onClick: openAddressModal
            }, null, 8, _hoisted_46), [
              [_vModelText, userInfo.value.m_addr]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "address-btn",
              onClick: openAddressModal,
              disabled: loading.value
            }, " 검색 ", 8, _hoisted_47)
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _cache[67] || (_cache[67] = _createElementVNode("label", { class: "info-label" }, "상세주소", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((userInfo.value.m_addr_detail) = $event)),
            type: "text",
            class: "info-input",
            placeholder: "상세주소를 입력해주세요",
            disabled: loading.value,
            maxlength: "100"
          }, null, 8, _hoisted_49), [
            [_vModelText, userInfo.value.m_addr_detail]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("button", {
          class: "save-btn",
          onClick: updateUserInfo,
          disabled: loading.value || !isFormValid.value
        }, [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "white",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
              _createTextVNode("mdi-content-save", -1)
            ]))]),
            _: 1
          }),
          _cache[70] || (_cache[70] = _createTextVNode(" 정보 수정 ", -1))
        ], 8, _hoisted_51),
        _createElementVNode("button", {
          class: "password-btn",
          onClick: openPasswordModal,
          disabled: loading.value
        }, [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "#1e3a8a",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
              _createTextVNode("mdi-lock-reset", -1)
            ]))]),
            _: 1
          }),
          _cache[72] || (_cache[72] = _createTextVNode(" 비밀번호 변경 ", -1))
        ], 8, _hoisted_52)
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: passwordDialog.value,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((passwordDialog).value = $event)),
      "max-width": "90%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "#1e3a8a",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                    _createTextVNode("mdi-lock-reset", -1)
                  ]))]),
                  _: 1
                }),
                _cache[74] || (_cache[74] = _createTextVNode(" 비밀번호 변경 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "modal-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_53, [
                  _cache[75] || (_cache[75] = _createElementVNode("label", { class: "modal-label" }, [
                    _createTextVNode("현재 비밀번호 "),
                    _createElementVNode("span", { class: "required" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_54, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((passwordData.value.currentPassword) = $event)),
                      type: showCurrentPassword.value ? 'text' : 'password',
                      class: "modal-input",
                      placeholder: "현재 비밀번호를 입력하세요",
                      disabled: passwordLoading.value,
                      maxlength: "50"
                    }, null, 8, _hoisted_55), [
                      [_vModelDynamic, passwordData.value.currentPassword]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "password-toggle",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (showCurrentPassword.value = !showCurrentPassword.value))
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(showCurrentPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _cache[76] || (_cache[76] = _createElementVNode("label", { class: "modal-label" }, [
                    _createTextVNode("새 비밀번호 "),
                    _createElementVNode("span", { class: "required" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_57, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((passwordData.value.newPassword) = $event)),
                      type: showNewPassword.value ? 'text' : 'password',
                      class: "modal-input",
                      placeholder: "새 비밀번호를 입력하세요",
                      disabled: passwordLoading.value,
                      onInput: validatePassword,
                      maxlength: "50"
                    }, null, 40, _hoisted_58), [
                      [_vModelDynamic, passwordData.value.newPassword]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "password-toggle",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (showNewPassword.value = !showNewPassword.value))
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(showNewPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _cache[77] || (_cache[77] = _createElementVNode("label", { class: "modal-label" }, [
                    _createTextVNode("새 비밀번호 확인 "),
                    _createElementVNode("span", { class: "required" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_60, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((passwordData.value.confirmNewPassword) = $event)),
                      type: showConfirmNewPassword.value ? 'text' : 'password',
                      class: "modal-input",
                      placeholder: "새 비밀번호를 다시 입력하세요",
                      disabled: passwordLoading.value,
                      onInput: validatePassword,
                      maxlength: "50"
                    }, null, 40, _hoisted_61), [
                      [_vModelDynamic, passwordData.value.confirmNewPassword]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "password-toggle",
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (showConfirmNewPassword.value = !showConfirmNewPassword.value))
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(showConfirmNewPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (passwordError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(passwordError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "modal-actions" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "cancel-btn",
                  onClick: closePasswordModal,
                  disabled: passwordLoading.value
                }, " 취소 ", 8, _hoisted_63),
                _createElementVNode("button", {
                  class: "confirm-btn",
                  onClick: changePassword,
                  disabled: passwordLoading.value || !isPasswordValid.value
                }, " 변경하기 ", 8, _hoisted_64)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: addressDialog.value,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((addressDialog).value = $event)),
      "max-width": "90%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-title" }, {
              default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                _createTextVNode("주소 검색", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { style: {"height":"420px","position":"relative"} }, {
              default: _withCtx(() => [
                (addressLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "#1e3a8a",
                        size: "48"
                      }),
                      _cache[79] || (_cache[79] = _createElementVNode("div", { class: "loading-text" }, "주소 검색을 불러오는 중...", -1))
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", {
                  ref_key: "postcodeContainer",
                  ref: postcodeContainer,
                  style: {"width":"100%","height":"100%"}
                }, null, 512), [
                  [_vShow, !addressLoading.value]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "modal-actions" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "cancel-btn",
                  onClick: _cache[38] || (_cache[38] = ($event: any) => (addressDialog.value = false)),
                  disabled: addressLoading.value
                }, " 닫기 ", 8, _hoisted_66)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(LodingComponent, {
      "is-visible": loading.value || passwordLoading.value,
      text: loadingText.value
    }, null, 8, ["is-visible", "text"])
  ]))
}
}

})